<template>
    <div class="custom-modal-backdrop" @click.self="preventClose">
        <section class="custom-modal">
            <div class="custom-modal-header">
                <div class="user-info">
                    <span>
                        <span v-if="user.active == 1" title="Supervisor"><i class="fas fa-user text-danger"></i></span>
                        <span v-if="user.active == 2" title="Operador"><i class="fas fa-user text-primary"></i></span>
                        {{ user.name }} ({{ user.extension_line }})</span>
                </div>
                <div class="close-button" @click="closeModal">
                    <i class="fas fa-times"></i>
                </div>
            </div>
            <div class="custom-modal-body">
                <div v-if="mode === 'manage'" class="batch-action-buttons">
                    <div class="pause-button"  @click="openPauseMenu($event, user.queues)">Pausar todas</div>
                    <div class="unpause-button" @click="unpause(user.queues)">Despausar todas</div>
                </div>
                <div class="queues-table-container">
                    <div v-if="user.queues.length" class="table-wrapper">
                        <div class="table-header" :class="{ 'manage-mode': mode === 'manage' }">
                            <div class="header-cell">Fila</div>
                            <div v-if="mode === 'manage'" class="header-cell">Status</div>
                            <div class="header-cell">Motivo</div>
                            <div class="header-cell">Tempo Máximo de Pausa</div>
                            <div class="header-cell">Duração</div>
                            <div v-if="mode === 'manage'" class="header-cell">Ação</div>
                        </div>
                        <div class="table-body">
                            <table class="custom-table">
                                <tbody>
                                    <tr v-for="q in user.queues" :key="q.name" :class="{ 'manage-mode': mode === 'manage' }">
                                        <td>{{ q.name }}</td>
                                        <td v-if="mode === 'manage'">
                                            <span :class="['status-badge', `status-${q.status?.toLowerCase()}`]">
                                                {{ q.status === 'paused' ? 'Em pausa' : 'Ativo' }}
                                            </span>
                                        </td>
                                        <td>{{ q.pauseReason || '-' }}</td>
                                        <td>{{ maxTimeInPause(q.pauseReason) }}</td>
                                        <td>
							                <i class="far fa-clock mr-1" :class="getPauseColorClass(q.lastPause, q.pauseReason, true)"></i>
                                            {{ secondsToTime(q.lastPause) || '-' }}
                                        </td>
                                        <td v-if="mode === 'manage'">
                                            <div 
                                                v-if="q.status === 'paused'" 
                                                class="unpause-button"
                                                @click="unpause([q])"
                                                >Despausar</div>
                                            <div 
                                                v-else 
                                                class="pause-button"
                                                @click="openPauseMenu($event, [q])"
                                            >Pausar</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="no-queues">
                        <i class="fas fa-inbox"></i>
                        <p>Nenhuma fila vinculada</p>
                    </div>
                </div>
            </div>
        </section>
        <div
            v-if="pauseMenuVisible"
            class="pause-context-menu"
            :style="{ top: menuPosition.y + 'px', left: menuPosition.x + 'px' }"
            @click.stop
        >
            <div
                v-for="(reason, index) in pauseReasons"
                :key="index"
                class="pause-menu-item"
                @click="selectPauseReason(reason)"
            >
                <span>{{ reason }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PauseDetails",
        props: ['user', 'mode', 'pausesList'],
        data(){
            return {
                pauseMenuVisible: false,
                menuPosition: { x: 0, y: 0 },
                selectedQueues: [],
                previousUser: null,
                pauseTimer: null,
                currentTime: Math.floor(Date.now() / 1000)
            }
        },
        computed: {
            pauseReasons(){
                const temp = [];
                if(this.pausesList.length){
                    this.pausesList.map(pause => {
                        temp.push(pause.name)
                    })
                }
                return temp
            }
        },
        mounted(){
            this.startTimeUpdater();
        },
        beforeUnmount() {
            document.removeEventListener('click', this.closePauseMenu);
            this.stopTimeUpdater();
        },
        methods: {
            closeModal(){
                this.previousUser = null
                this.stopTimeUpdater();
                this.$emit('close-modal');
            },
            preventClose(){},
            pause(queues, disabled = false, reason){
			    if(disabled || !queues.length) return;
			    queues = queues.map(el => el.name)
			    this.$emit('emitIntermediate', {payload: {id: this.user.id, extension_line: this.user.extension_line, queues, reason}, event: 'pause'})
		    },
		    unpause(queues, disabled = false){
		    	if(disabled || !queues.length) return;
		    	queues = queues.map(el => el.name)
		    	this.$emit('emitIntermediate', {payload: {id: this.user.id, extension_line: this.user.extension_line, queues}, event: 'unpause'})
		    },
            openPauseMenu(event, queue) {
                event.stopPropagation();

                // Calcular posição do menu
                const rect = event.target.getBoundingClientRect();
                this.menuPosition = {
                    x: rect.left,
                    y: rect.bottom + 5
                };

                this.selectedQueues = queue;

                this.pauseMenuVisible = true;

                // Adicionar listener para fechar o menu ao clicar fora
                setTimeout(() => {
                    document.addEventListener('click', this.closePauseMenu);
                }, 0);
            },
            closePauseMenu() {
                this.pauseMenuVisible = false;
                this.selectedQueues = [];
                document.removeEventListener('click', this.closePauseMenu);
            },
            selectPauseReason(reason) {
                if (this.selectedQueues.length) {
                    this.pause(this.selectedQueues, false, reason);
                }
                this.closePauseMenu();
            },
            secondsToTime(timestamp) {
                if(!timestamp) return '00:00:00';

                let startTime = Number(timestamp);
                const seconds = this.currentTime - startTime; // Use this.currentTime ao invés de Date.now()

                if(seconds < 0) {
                    console.error('ERRO: Timestamp está no futuro!');
                    console.log('timestamp', timestamp)
                    return '00:00:00';
                }
            
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const secs = Math.floor(seconds % 60);
            
                const pad = (num) => String(num).padStart(2, '0');
            
                return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
            },
            calcPauseTimer() {
		    	clearInterval(this.pauseTimer);
		    	this.pauseTimer = setInterval(() => {
                    if (this.user.queues.length) {
                        if (this.user.queues.some(el => el.status === 'paused')) {
                            // this.user.queues.map(q => {
                            //     if (q.status === 'paused') {
                            //         if(this.user.id == '286'){
                            //             console.log('q.lastPause', q.lastPause)
                            //         }
                            //         // q.lastPause = q.lastPause
                            //     }
                            // })
                            this.$forceUpdate();
                        }
                    }
		    	}, 1000)
		    },
            maxTimeInPause (pauseReason) {
                if (['Descanso 1', 'Descanso 2'].includes(pauseReason)){
                    return '10 Minutos';
                }

                if (['Lanche'].includes(pauseReason)){
                    return '20 Minutos';
                }

                return '-';
            },
            // Calcula a cor com base na diferença de tempo
            getPauseColorClass(timestamp, pauseReason, isIcon) {
                if (!timestamp || !pauseReason) return 'text-secondary'; 

                const seconds = this.currentTime - Number(timestamp);

                // PAUSA PARA OS DESCANSOS
                if (['Descanso 1', 'Descanso 2'].includes(pauseReason)) {
                    // Acima de 10 min (600s)
                    if (seconds >= 600) {
                        return 'text-danger blink-anim font-weight-bold'; 
                    } 
                    // Entre 6 min (360s) e 10 min
                    else if (seconds >= 360) {
                        return isIcon ? 'text-warning font-weight-bold' : 'font-weight-bold text-dark'; 
                    }
                    return 'text-dark';
                }
                // PAUSA PARA O LANCHE
                if (pauseReason === 'Lanche') {
                    // Acima de 20 min (1200s)
                    if (seconds >= 1200) {
                        return 'text-danger blink-anim font-weight-bold'; 
                    } 
                    // Entre 16 min (960s) e 20 min
                    else if (seconds >= 960) {
                        return isIcon ? 'text-warning font-weight-bold' : 'font-weight-bold text-dark'; 
                    }
                    return 'text-dark';
                }
                
                return 'text-dark';
            },
            startTimeUpdater() {
                clearInterval(this.pauseTimer);
                this.pauseTimer = setInterval(() => {
                    this.currentTime = Math.floor(Date.now() / 1000);
                }, 1000);
            },
            stopTimeUpdater() {
                clearInterval(this.pauseTimer);
            }
        },
        watch: {
            user: {
                handler(newValue, oldValue){
                    // if(newValue.paused){
                    //     this.calcPauseTimer()
                    // }

                    if(!this.previousUser) {
                        this.previousUser = JSON.parse(JSON.stringify(newValue))
                        return
                    }

                    if(this.mode === 'view'){
                        if(!newValue.paused && this.previousUser.paused) {
                            this.closeModal()
                        }
                    }
            
                    // Atualiza o previousUser para a próxima comparação
                    this.previousUser = JSON.parse(JSON.stringify(newValue))
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .custom-modal {
        position: relative; 
        top: auto;
        left: auto;
        transform: none;
        background: white;
        border-radius: 5px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
        height: 70vh;
        width: 800px;
        max-width: 90vw;
        display: flex;
        flex-direction: column;
        gap: 10px;
        animation: slideIn 0.3s ease;

        &-header {
            display: flex;
            justify-content: space-between;
            padding: 15px 20px;
            align-items: center;
            gap: 20px;
            background: linear-gradient(135deg, #a88210 0%, #856404 100%);
            border-radius: 5px 5px 0 0;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

            .user-info {
                color: #ffffff;
                font-weight: 600;
                font-size: 1rem;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

                .fa-user {
                    margin-right: 5px;

                    &.text-danger {
                        color: #ff6b6b;
                    }

                    &.text-primary {
                        color: #4dabf7;
                    }
                }
            }
        
            .close-button {
                cursor: pointer;
                font-size: 1.2rem;
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: rgb(13 12 12 / 28%);
                transition: all 0.3s ease;
            
                i {
                    color: #ffffff;
                    transition: transform 0.3s ease;
                }
            
                &:hover {
                    background: rgba(255, 255, 255, 0.2);
                    transform: scale(1.1);
                
                    i {
                        transform: rotate(90deg);
                    }
                }
            
                &:active {
                    transform: scale(0.95);
                }
            }
        }

        &-body {
            flex: 1; 
            overflow: hidden;
            padding: 0 15px 15px;
            display: flex;
            flex-direction: column;

            .queues-table-container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;

                .table-wrapper {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }

                .table-header {
                    flex-shrink: 0;
                    display: grid;
                    grid-template-columns: 1.5fr 1.5fr 1.5fr 1.5fr;
                    background: white;
                    border-bottom: 2px solid #e0e0e0;

                    &.manage-mode {
                        grid-template-columns: 1.5fr 1fr 1.5fr 1.5fr 1fr;
                    }

                    .header-cell {
                        padding: 12px 15px;
                        color: #927622;
                        text-align: center;
                        font-weight: 600;
                        text-transform: uppercase;
                        font-size: smaller;
                        letter-spacing: 0.5px;
                    }
                }
            
                .table-body {
                    flex: 1;
                    overflow-y: auto;
                    overflow-x: hidden;
                }

                .custom-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 0.9rem;
                
                    tbody tr {
                        display: grid;
                        grid-template-columns: 1.5fr 1.5fr 1.5fr 1.5fr;
                        border-bottom: 1px solid #f0f0f0;
                        transition: all 0.3s ease;

                        &.manage-mode {
                            grid-template-columns: 1.5fr 1fr 1.5fr 1.5fr 1fr;
                        }
                    
                        &:nth-of-type(even) {
                            background-color: #f8f9fa;
                        }
                    
                        &:hover {
                            background-color: #b1d9f5;
                            transform: scale(1.01);
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                        }
                    }
                
                    td {
                        padding: 12px 15px;
                        color: #333;
                        text-align: center;
    
                        &:first-child {
                            text-align: left;
                        }
                    }
                
                    .status-badge {
                        display: inline-block;
                        padding: 4px 12px;
                        border-radius: 12px;
                        font-size: x-small;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    
                        &.status-ativo,
                        &.status-logged {
                            background-color: #d4edda;
                            color: #155724;
                        }
                    
                        &.status-pausado,
                        &.status-paused {
                            background-color: #fff3cd;
                            color: #856404;
                        }
                    
                        &.status-inativo,
                        &.status-inactive {
                            background-color: #f8d7da;
                            color: #721c24;
                        }
                    }
                }

                .no-queues {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 60px 20px;
                    color: #999;

                    i {
                        font-size: 3.5rem;
                        margin-bottom: 20px;
                        opacity: 0.5;
                    }

                    p {
                        font-size: 1.1rem;
                        margin: 0;
                    }
                }
            }

            .batch-action-buttons {
                display: flex;
                gap: 10px;
                justify-content: flex-end;
                margin: 5px;
            }

            .unpause-button,
            .pause-button {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 6px 16px;
                border-radius: 6px;
                font-size: x-small;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                text-shadow: 1px 1px 1px black;
            
                &:active {
                    transform: scale(0.95);
                }
            }

            .unpause-button {
                background: linear-gradient(135deg, #165c27 0%, #168563 100%);
                color: white;
                border: 1px solid #20a745;
            
                &:hover {
                    background: linear-gradient(135deg, #20a745 0%, #1bb389 100%);
                    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
                    transform: translateY(-2px);
                }
            }

            .pause-button {
                background: linear-gradient(135deg, #b8993c 0%, #ffe600 100%);
                color: white;
                border: 1px solid #ffb300;
            
                &:hover {
                    background: linear-gradient(135deg, #9b8133 0%, #a59718 100%);
                    box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);
                    transform: translateY(-2px);
                }
            }
        }
    }

    .custom-modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideIn {
        from {
            transform: translateY(-50px);
        }
        to {
            transform: translateY(0);
        }
    }

    .pause-context-menu {
        position: fixed;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        padding: 8px 0;
        min-width: 220px;
        z-index: 10000;
        animation: menuSlideIn 0.2s ease;

        .pause-menu-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 12px 16px;
            cursor: pointer;
            transition: all 0.2s ease;
            color: #333;
            font-size: 0.9rem;

            i {
                width: 20px;
                text-align: center;
                color: #927622;
                font-size: 1rem;
            }

            &:hover {
                background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%);
                color: #856404;

                i {
                    color: #856404;
                    transform: scale(1.1);
                }
            }

            &:active {
                background: linear-gradient(135deg, #ffe69c 0%, #ffd43b 100%);
                transform: scale(0.98);
            }

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-radius: 0 0 8px 8px;
            }
        }
    }

    @keyframes menuSlideIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .action-cell {
        position: relative;
    }

    /* Animação para o tempo acima de 10 minutos */
    @keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 0.2; }
        100% { opacity: 1; }
    }

    .blink-anim {
        animation: blink 1s linear infinite;
    }
</style>